// I don't know why do we need it
// TODO find out why do we need it
export var defaultReplacementText = {
    GeneralDescription: {
        title: 'Business Name',
        practice1: 'practice1',
        practice3: 'practice3',
        teamMember1: 'teamMember1',
        teamMember3: 'teamMember3',
        newsItemTitle2: 'newsItemTitle2',
        clientName2: 'clientName2',
        eventName2: 'eventName2',
        eventName3: 'eventName3',
        industry2: 'industry2',
        service: 'service',
        typeOfTrip1: 'typeOfTrip1',
        typeOfTrip3: 'typeOfTrip3',
        vacationSpecial1: 'vacationSpecial1',
        vacationSpecial3: 'vacationSpecial3',
        newsItem1: 'newsItem1',
        newsItem3: 'newsItem3',
        customerName1: 'customerName1',
        customerName3: 'customerName3',
        jobTitle2: 'jobTitle2',
        date: 'date',
        industry1: 'industry1',
        industry3: 'industry3',
        travelDestination1: 'travelDestination1',
        travelDestination3: 'travelDestination3',
        newsItemDate: 'newsItemDate',
        companySize: 'companySize',
        practice2: 'practice2',
        yearFounded: 'yearFounded',
        city: 'city',
        teamMember2: 'teamMember2',
        year: 'year',
        openingHours: 'openingHours',
    },
};
//# sourceMappingURL=defaultReplacementText.js.map